import { Stack } from "@altimateai/lego";
import quickstartMan from "../../../assets/images/quickstart-man.png";
import quickstartHeadBg from "../../../assets/images/quickstart-head-bg.png";

function QuickstartHeader() {
  return (
    <Stack
      direction="row"
      align="center"
      className="al-relative al-h-[120px] sm:al-h-[140px] md:al-h-[160px] lg:al-h-[180px] al-w-full al-bg-no-repeat al-bg-cover al-rounded-lg al-overflow-hidden"
      style={{ backgroundImage: `url(${quickstartHeadBg})` }}
    >
      <h2 className="al-font-['bebas'] al-text-[32px] sm:al-text-[40px] md:al-text-[50px] lg:al-text-[60px] al-leading-tight al-p-3 sm:al-p-4 lg:al-p-5 al-text-white al-text-center sm:al-text-left al-w-full sm:al-w-auto">
        TAKE A STEP,
        <br />
        IT&apos;S <span className="al-text-emerald-300">QUICK</span> &amp;{" "}
        <span className="al-text-emerald-300">EASY!</span>
      </h2>
      <img
        src={quickstartMan}
        alt=""
        className="al-absolute al-h-[95%] al-top-[5%] al-right-2.5 al-hidden sm:al-block"
      />
    </Stack>
  );
}

export default QuickstartHeader;
